import { error, finish } from '../../../modules/liabilities/actions/avg-net-payout';
import api from '../../../api';

export function request(dispatch) {
    api.get('/liabilities-alerts/average-net-payout', void 0).then(
        result => dispatch(finish( result ? result.selections : [])),
        errors => dispatch(error(errors))
    );
}
